/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Tysiav2WarningIcon from 'DesignSystem/Svgs/Tysiav2WarningIcon/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/ManualAutomations/Content/Content/ActiveAction/CreateProcedureReceivables/Content/Content/Info/Content"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--g-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal}`}
>
<Tysiav2WarningIcon
  viewPath={`${viewPath}/Tysiav2WarningIcon`}
 fill2="#E9B949"
 height={20}
 width={20}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="xsmall"
 text="Some charges from this appointment are claimable through insurance, but no insurance is set up on the patient profile. All charges have therefore been added to an invoice that should be settled by the payor."
 color={dtColorsNeutral600}
/>
</div>
{children}
</React.Fragment>)
}